/*
 * @Author: your name
 * @Date: 2022-03-09 14:16:28
 * @LastEditTime: 2024-07-29 10:30:28
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\i18n\language\yh_zh.js
 */
export default {
  basics: {
    Cancel: 'отменять',
    Confirm: 'определять',
    en: 'английский язык',
    zh: 'китайский язык',
    PleaseSelect: 'Пожалуйста выберите',
    PleaseInput: 'Пожалуйста, введите',
  },
  schedule: {
    //节目编辑
    Screenshot: 'скриншот',
    ProgramName: 'Название программы',
    Structure: 'структура',
    Resolution: 'разрешение',
    CreationTime: 'Время создания',
    operate: 'работать',
    AllLoaded: 'Все загружено',
    materialsLoaded: 'Нажмите, чтобы загрузить материал',
    NewProgram: 'Новая программа+',
    DelProgram: 'Вы хотите безвозвратно удалить выбранную в данный момент программу?',
    DeleteMedia: 'Удаление носителя',
    //高级发布
  },
  review: {
    Screenshot: 'скриншот',
    ProgramName: 'Название программы',
    Structure: 'структура',
    Resolution: 'разрешение',
    CreationTime: 'Время создания',
    operate: 'работать',
    Review: 'аудит',
    Check: 'проверить',
    ProgramMaterial: 'Программный материал',
    ProgramPreview: 'Предварительный просмотр программы',
    ReviewContent: 'Пожалуйста, ознакомьтесь с содержанием обзора',
    Approved: 'Прошел аудит',
    RejectReview: 'Отказываются проходить',
    DeleteAll: 'Подтверждаете удаление всех?',
    Name: 'название',
    Size: 'Размер',
    Preview: 'Предварительный просмотр',
    ProgramReview: 'Обзор программы',
    ReasonRefusal: 'Пожалуйста, укажите причину отказа!',
    number: 'Номер регистрационного талона не указан',
  },
  system: {
    // 组织结构
    StructureName: 'Название организационной структуры',
    Operate: 'работать',
    NewStructure: 'Новая организационная структура',
    DeleteStructure: 'Удалить организационную структуру',
    Structure: 'структура',
    MsgDeleteStructure: 'Вы хотите удалить текущий файл навсегда?',
    OnDevice: 'Включить устройство',
    OffDevice: 'Выключить устройство',
    inquiry: 'ПРИ',
    on: 'включении',
    off: 'выключите',
    slaveDevice: 'текущее или ведомое устройство',
    CloseCurrent: 'Закрыть текущее',
    CloseSlave: 'Закрыть ведомое',
    OpenCurrent: 'Открыть текущее',
    OpenSlave: 'Открыть ведомое',
    // 用户管理
    Account: 'счет',
    Name: 'полное имя',
    Role: 'роль',
    Grade: 'уровень',
    Remark: 'Замечания',
    RoleName: 'Имя персонажа',
    Password: 'код',
    ConfirmPass: 'Подтвердите пароль',
    Mail: 'электронная почта',
    DeleteUser: 'Удалить пользователя',
    DeleteRole: 'Удалить текущую роль навсегда',
    UnblockDevice: 'Разблокировать устройство',
    banDevice: 'Заблокировать устройство',
    Unblock: 'Разблокировать',
    ban: 'Запрещенный',
    BanTheCurrent: 'Заблокировать текущего участника',
    BannedAffiliate: 'Заблокированный партнер',
    ReleaseTheCurrent: 'Освободить текущего участника',
    ReleaseTheSubordinate: 'Освободить подчиненного',
    AddUser: 'Новые пользователи',
    ModifyUser: 'Изменить пользователя',
    inputPassword: 'Пожалуйста, введите пароль для подтверждения',
    noPassword: 'Пароли, введенные дважды, не совпадают!',
    inputName: 'Пожалуйста, введите свое имя',
    RoleEmpty: 'Имя роли не может быть пустым',
    StructureEmpty: 'Имя структуры не может быть пустым',
    AccountEmpty: 'Учетная запись не должна быть пустой',
    AccountAstrict: 'Учетная запись содержит только цифры, буквы и символы подчеркивания!',
    AccountLength: 'Пожалуйста, укажите длину учетной записи от 3 до 20 символов!!',
    AccountRegistered: 'Текущая учетная запись была зарегистрирована, пожалуйста, войдите повторно!',
    // 角色管理
    AddRole: 'Новая роль',
    RoleRemark: 'Замечания о персонаже',
    RightConfig: 'Правильная конфигурация',
    DelRole: 'Удалить роль',
    // 系统设置
    imageSize1: 'Рекомендуется использовать изображение в формате PNG размером 920х940 пикселей',
    ReplacePicture: 'Заменить изображение',
    LoginLogo: 'ЛОГОТИП страницы входа в систему',
    imageSize2: 'Рекомендуются изображения в формате PNG с рекомендуемым размером 360x80 пикселей',
    SystemLogo: 'ЛОГОТИП системной страницы',
    systemSettings: 'Другие системные настройки',
    configInformation: 'Другая информация о конфигурации',
    DailyLimit: 'Дневной лимит применения',
    UploadedType: 'Загруженное изображение аватара может быть только в формате PNG!',
    UploadedSize: 'Размер загруженного изображения аватара не может превышать 2 МБ!',
    // 节点管理
    addNode: 'Добавить узел',
    EnglishName: 'Английское имя',
    ChineseName: 'Китайское имя',
    delNode: 'Окончательно удалить текущую роль?',
    // 软件授权
    AuthorizationType: 'Тип кода авторизации',
    Model: 'модель',
    Date: 'дата',
    AuthorizationCode: 'код авторизации',
  },
  // 节目编辑
  programEditing: {
    Setting: 'Установка',
    Save: 'сохранить',
    Release: 'сообщать',
    Quit: 'выходить из',
    ExitEditProgram: 'Выход приведет к удалению редактируемой в данный момент программы',
    DragMaterial: 'Перетащите файл с материалами сюда',
    SaveWait: 'Скриншоты и сохранение, пожалуйста, подождите...',
    ProgramList: 'Список окон',
    multimedia: 'Мультимедиа',
    AddMultimedia: 'Добавить мультимедиа',
    Insert: 'Вставить в текущее положение',
    properties: 'Свойства',
    materialNull: 'Пожалуйста, добавьте материал в окно',
    Uploaded: 'Закачанный',
    AllLoaded: 'Все загружено',
    materialsLoaded: 'Нажмите, чтобы загрузить материал',
    Text: 'текст',
    Digital: 'Цифровые часы',
    Analog: 'Аналоговые часы',
    Weather: 'погода',
    Timing: 'Синхронизация',
    Countdown: 'обратный отсчет',
    StreamMedia: 'Потоковое мультимедиа',
    RSS: 'RSS-канал',
    Window: 'окно',
    Picture: 'картинка',
    Video: 'видео',
    Delete: 'стирать',
    Webpage: 'Веб-страница',
    OneLayerUp: 'Поднимитесь на один уровень выше',
    OneLayerDown: 'Следующий уровень',
    Top: 'Самый верхний',
    Bottom: 'Самый нижний слой',
    Full: 'Полноэкранный режим',
    HorizontalFull: 'Горизонтальное мощение',
    VerticalFull: 'Вертикально покрытый',
    VerticalDown: 'Вертикально вниз',
    VerticalMiddle: 'Вертикально центрированный',
    VerticalTop: 'Вертикально вверх',
    HorizontalLeft: 'Горизонтально влево',
    HorizontalCenter: 'Центрированный по горизонтали',
    HorizontalRight: 'Горизонтально вправо',
    ProgramName: 'Название программы',
    Structure: 'структура',
    DeviceType: 'Тип устройства',
    Resolution: 'разрешение',
    CustomResolution: 'Пользовательское разрешение',
    Device: 'Устройство',
    SelectDevice: 'Пожалуйста, выберите устройство',
    SelectTerminal: 'Выберите терминал публикации',
    TerminalName: 'Название терминала',
    DeviceStatus: 'Состояние устройства',
    Offline: 'не в сети',
    AdaptiveScreen: 'Воспроизведение с учетом размера экрана',
    Tip: 'подсказка',
    Thumbnail: 'Эскиз',
    Name: 'название',
    version: 'Номер версии',
    Title: 'Заглавие',
    TimerMode: 'Временной режим',
    RelativeTime: 'Относительное время',
    AbsoluteTime: 'Абсолютное время',
    DisplayMode: 'Режим отображения',
    Day: 'день',
    Hour: 'час',
    Minutes: 'минута',
    Second: 'Второй',
    EditStyle: 'Редактировать стиль',
    DisplayUsage: 'Редактировать стиль',
    ARow: 'Одиночная строка',
    MultiRow: 'Несколько строк',
    FontFamily: 'Семейство шрифтов',
    BackgroundColor: 'Цвет фона',
    FontColor: 'Цвет шрифта',
    PlayTime: 'Время игры',
    Describe: 'Описывать',
    HourMark: 'Часовая метка',
    HourHand: 'Стрелка часов',
    MinutesMark: 'Минутная метка',
    MinutesHand: 'минута',
    background: 'Фоновая стрелка секундной стрелки',
    secondHand: 'секунда',
    DateAndDay: 'Дата и день',
    Display: 'Дисплей',
    SelectTimeZone: 'Выберите временную зону',
    Scale: 'Масштаб',
    ConstrainProportions: 'Ограничьте пропорции',
    EnterTheAnimation: 'Введите анимацию',
    TheEntryTime: 'Начальное время',
    Data: 'дата',
    Time: 'Время',
    ChineseCalendar: 'Китайский календарь',
    Week: 'Неделя',
    DateFormat: 'Формат даты',
    Font: 'Шрифт',
    Roll: 'Рулон',
    FlipOver: 'Переворачивание',
    Motionless: 'Неподвижный',
    RollingDirection: 'Изменяющееся направление',
    RollingVelocity: 'Изменяющаяся скорость',
    FromLeftToRight: 'Слева направо',
    FromRightToLeft: 'справа налево',
    FromTopToBottom: 'Сверху вниз',
    FromTheBottomUp: 'С самого начала',
    Attribute: 'Атрибут',
    AttendedMode: 'Посещаемый режим',
    EndToEnd: 'Из конца в конец',
    VolumeAdjust: 'Регулировка громкости',
    Duration: 'Продолжительность',
    Address: 'Адрес',
    City: 'Город',
    Temp: 'температура',
    WindPower: 'Ветер',
    Humidity: 'влажность',
    DressingIndex: 'Индекс одежды',
    PlayTheWay: 'Играй по-своему',
    TimeFormat1: '00:00:00:00',
    TimeFormat2: '00D00H00M00S',
  }
}
